<template>
  <div>
    <Header :title="'删除纪念馆'" />
    <div class="container flex-column-center-center">
      <div class="notice">删除后将不可恢复,是否确认删除</div>
      <i class="iconfont warn-icon">&#xe72f;</i>
      <div class="service-section">
        <nut-checkbox v-model="checkbox">
          <span>我已阅读并同意</span>
        </nut-checkbox>
        <span class="service-terms" @click="termsOpen">《纪念馆删除协议》</span>
      </div>
      <div class="btn-wrap">
        <div class="btn btn-back" @click="toBack">返回</div>
        <div class="btn btn-true" @click="toDelete">确认</div>
      </div>
    </div>
    <van-dialog v-model="showDialog" :title="deleteData.title">
      <div class="delete_text" v-html="deleteData.content" />
    </van-dialog>
  </div>
</template>

<script>
import Header from '@/components/Header/Index'
import { HallDelete } from '@/api//Personal/Hall'
import { Toast } from '@nutui/nutui'
import { Dialog } from 'vant'
import { getSinglepage } from '@/api/Comm/index'

export default {
  name: 'HallCreateSuccess',
  components: {
    Header,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      hallId: 0,
      checkbox: false,
      showDialog: false,
      deleteData: {
        code: 'Delete',
        title: '',
        content: '',
        name: ''
      }
    }
  },
  mounted() {
    const { id } = this.$route.params
    this.hallId = Number(id)
    this.initPage()
  },
  methods: {
    initPage() {
      getSinglepage(this.deleteData.code).then(res => {
        if (res && res.success) {
          this.deleteData.title = res.data.title
          this.deleteData.content = this.$resImg(res.data.content)
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 返回
    toBack() {
      this.$router.go(-1)
    },
    termsOpen() {
      this.showDialog = true
    },
    // 确认删除
    toDelete() {
      if (!this.checkbox) {
        Toast.fail('请勾选“我已阅读并同意”')
        return
      }
      HallDelete(this.hallId).then(res => {
        if (res && res.success) {
          Toast.success('删除成功')
          this.$router.go(-1)
        } else {
          Toast.fail(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: calc(100vh - 36px);

  .notice {
    margin-bottom: 30px;
    font-size: 22px;
    color: #666;
  }

  .warn-icon {
    margin-bottom: 30px;
    font-size: 68px;
    color: rgb(197, 82, 60);
  }
  .service-section {
    margin-bottom: 25px;
    color: #666;
    .nut-checkbox {
      ::v-deep input {
        border-radius: 3px;
      }

      ::v-deep input:checked {
        background-color: $primary-color-bright;
        border-color: $primary-color-bright;
      }
    }
    .service-terms {
      font-size: 14px;
      font-weight: bold;
      color: $primary-color-bright;
    }
  }
  .btn-wrap {
    width: 100%;
    padding: 0px 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .btn {
      width: 160px;
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      font-size: 17px;
      letter-spacing: 2px;
      text-align: center;
    }

    .btn-back {
      background: #fff;
      color: #f3a914;
      box-shadow: 0px 0px 10px rgba(220, 220, 220, 0.5);
    }

    .btn-true {
      background: linear-gradient(to right, #f2a612, #f7c827);
      color: #fff;
    }
  }
}
.delete_text{
  padding: 0px 15px;
  font-size: 13px;
  color: #333;
  line-height: 20px;
  max-height: 400px;
  overflow: auto;
}
</style>
